import { render, staticRenderFns } from "./Good.vue?vue&type=template&id=4b0f4468&scoped=true&"
import script from "./Good.vue?vue&type=script&lang=js&"
export * from "./Good.vue?vue&type=script&lang=js&"
import style0 from "./Good.vue?vue&type=style&index=0&id=4b0f4468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f4468",
  null
  
)

export default component.exports